import { translate } from "app/filters/i18nFilter";

import { EAdType } from "app/components/keyword-research/AdColumnUnit";

export const TEXT = "Text";
export const SHOPPING = "Shopping";
const SEARCH_ADS_TABLE_PREFIX = "keyword.research.search.ads.table";
export const WORLD_WIDE = "999";

export const TABLE_COLUMN_AD_TYPE = "adType";
export const TABLE_COLUMN_AD_DETAILS = "adDetails";
export const TABLE_COLUMN_CLICKS_SHARE = "clicksShare";
export const TABLE_COLUMN_POSITION = "position";
export const TABLE_COLUMN_CLICKS_CHANGE = "clicksChange";
export const TABLE_COLUMN_VOLUME = "volume";
export const TABLE_COLUMN_KEYWORDS_COUNT = "keywordsCount";
export const TABLE_COLUMN_AVG_CPC = "avgCpc";
export const TABLE_COLUMN_CPC = "cpc";
export const TABLE_COLUMN_TOP_KEYWORD = "topKeyword";
export const TABLE_COLUMN_LANDING_PAGE = "landingPage";
export const TABLE_COLUMN_AVG_VOLUME = "avgVolume";
export const TABLE_COLUMN_KEYWORD = "keyword";
export const TABLE_COLUMN_DOMAIN = "domain";

export const COLUMN_TOOLTIPS = {
    [TABLE_COLUMN_AD_TYPE]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_AD_TYPE}.tooltip`,
    [TABLE_COLUMN_AD_DETAILS]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_AD_DETAILS}.tooltip`,
    [TABLE_COLUMN_CLICKS_SHARE]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_CLICKS_SHARE}.tooltip`,
    [TABLE_COLUMN_POSITION]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_POSITION}.tooltip`,
    [TABLE_COLUMN_CLICKS_CHANGE]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_CLICKS_CHANGE}.tooltip`,
    [TABLE_COLUMN_VOLUME]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_VOLUME}.tooltip`,
    [TABLE_COLUMN_KEYWORDS_COUNT]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_KEYWORDS_COUNT}.tooltip`,
    [TABLE_COLUMN_AVG_CPC]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_AVG_CPC}.tooltip`,
    [TABLE_COLUMN_CPC]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_CPC}.tooltip`,
    [TABLE_COLUMN_TOP_KEYWORD]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_TOP_KEYWORD}.tooltip`,
    [TABLE_COLUMN_LANDING_PAGE]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_LANDING_PAGE}.tooltip`,
    [TABLE_COLUMN_AVG_VOLUME]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_AVG_VOLUME}.tooltip`,
    [TABLE_COLUMN_KEYWORD]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_KEYWORD}.tooltip`,
    [TABLE_COLUMN_DOMAIN]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_DOMAIN}.tooltip`,
};

export const COLUMN_TITLES = {
    [TABLE_COLUMN_AD_TYPE]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_AD_TYPE}.title`,
    [TABLE_COLUMN_AD_DETAILS]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_AD_DETAILS}.title`,
    [TABLE_COLUMN_CLICKS_SHARE]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_CLICKS_SHARE}.title`,
    [TABLE_COLUMN_POSITION]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_POSITION}.title`,
    [TABLE_COLUMN_CLICKS_CHANGE]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_CLICKS_CHANGE}.title`,
    [TABLE_COLUMN_VOLUME]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_VOLUME}.title`,
    [TABLE_COLUMN_KEYWORDS_COUNT]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_KEYWORDS_COUNT}.title`,
    [TABLE_COLUMN_AVG_CPC]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_AVG_CPC}.title`,
    [TABLE_COLUMN_CPC]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_CPC}.title`,
    [TABLE_COLUMN_TOP_KEYWORD]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_TOP_KEYWORD}.title`,
    [TABLE_COLUMN_LANDING_PAGE]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_LANDING_PAGE}.title`,
    [TABLE_COLUMN_AVG_VOLUME]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_AVG_VOLUME}.title`,
    [TABLE_COLUMN_KEYWORD]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_KEYWORD}.title`,
    [TABLE_COLUMN_DOMAIN]: `${SEARCH_ADS_TABLE_PREFIX}.${TABLE_COLUMN_DOMAIN}.title`,
};

export const adTypeColumnIconConfig = {
    [EAdType.PLA]: {
        iconName: "pla",
        tooltip: "organic.landing.pages.inner.table.ads.pla.tooltip",
    },
    [EAdType.PAID]: {
        iconName: "serp-paid",
        tooltip: "organic.landing.pages.inner.table.ads.paid.tooltip",
    },
    [EAdType.PAID_SITELINKS]: {
        iconName: "serp-paid-with-links",
        tooltip: "organic.landing.pages.inner.table.ads.paid_sitelinks.tooltip",
    },
};
